import React, { useEffect, useCallback, useRef } from "react";
import { initRequest } from "./learnosityPreviewInit";
import { initActivityRequest } from "../../../utils/activityPreviewIntit";
import { bindTTS } from "../../../utils/textToSpeech/textToSpeech";
import { getRequest, getRequestPublic } from "../../../api/user.service";
import $ from "jquery";

export default function PreviewPage(props: any) {
  let authorsApp;
  const isMounted = useRef(true);
  const initialization = useCallback(() => {
    if (isMounted.current && document.getElementById("learnosity-author")) {
      const callbacks = {
        readyListener: function () {
          authorsApp.on("render:item", function () {
            const item = authorsApp.getItem();
            if (props.onSetTextExplanation) {
              const item = authorsApp.getItem();
              props.onSetTextExplanation(
                item.questions[0].data.metadata?.distractor_rationale
              );
            }
            if (props.onSetRubric) {
              const item = authorsApp.getItem();
              props.onSetRubric(item.questions[0].data.metadata?.sample_answer);
            }
            if (props.itemRef && props.showTextToSpeech) {
              bindTTS(item, props.itemRef.split("-").pop());
            }

            $(
              "div.lds-alert-warning:contains('This item is used in activities')"
            ).hide();
          });
          authorsApp.on("render:widgets", () => {
            const showAnswerButton = document.querySelector(
              ".lrn-author-validate-questions-toggle"
            );
            if (showAnswerButton && props.itemRef && props.showTextToSpeech) {
              if (props.setShowTextToSpeech) props.setShowTextToSpeech(false);
            }
          });
        },
        errorListener: function (e) {
          console.log("Error Code ", e.code);
          console.log("Error Message ", e.msg);
          console.log("Error Detail ", e.detail);
        },
      };
      if (props.questionGuid) {
        const request = initRequest(props?.itemRef?.toString());
        getRequestPublic(
          props.questionGuid,
          props.languageId,
          JSON.stringify(request)
        ).then((response) => {
          if (response.data) {
            authorsApp = window["LearnosityAuthor"]?.init(
              response.data,
              callbacks
            );
          }
        });
      } else {
        const request = props?.itemRef
          ? initRequest(props?.itemRef?.toString())
          : initActivityRequest(props?.activityRef?.toString());
        getRequest("author", JSON.stringify(request)).then((response) => {
          if (response.data) {
            authorsApp = window["LearnosityAuthor"]?.init(
              response.data,
              callbacks
            );
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    initialization();

    // Clean-up function
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div
      className={`main-content custom-lrn-preview ${
        props.showTextToSpeech ? "text-to-speech-enabled" : ""
      }`}
    >
      <div id="learnosity-author"></div>
    </div>
  );
}
